export default __webpack_public_path__ + "static/hero-illustration-48f529b8985894839201a66513be3c11.svg";